import React from 'react';
import { apiService } from '../../services/apiService.js';

const EmailIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    />
  </svg>
);

export const localAuthProvider = {
  id: 'local',
  name: 'Email',
  buttonText: 'Continue with Email',
  description: 'Sign in or create an account with your email and password.',
  Icon: EmailIcon,
  // Local auth doesn't redirect - it shows a form instead
  showForm: true,
  async start() {
    // This provider uses a form, so start() won't be called directly
    // Return an indicator that form should be shown
    return { ok: true, showForm: true };
  },
  async login({ email, password }) {
    const response = await apiService.localLogin(email, password);
    if (response.ok && response.data && response.data.success) {
      return {
        ok: true,
        user: response.data.user,
        tokens: response.data.tokens,
      };
    }
    return {
      ok: false,
      error: response.data?.error || response.error || 'Login failed',
    };
  },
  async register({ email, password, name, companyName }) {
    const response = await apiService.localRegister(email, password, name, companyName);
    if (response.ok && response.data && response.data.success) {
      return {
        ok: true,
        user: response.data.user,
        tokens: response.data.tokens,
      };
    }
    return {
      ok: false,
      error: response.data?.error || response.error || 'Registration failed',
    };
  },
};
